import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HComponent } from '@k2/common/ui/components/heading/h.component';

@Component({
    selector: 'h1',
    templateUrl: 'h.component.html',
    styleUrls: ['h.component.scss', 'h1.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class H1Component extends HComponent {}
